import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from "uuid";
import initialState from './initialState';

import ReactGA from "react-ga4";
import { startAudioEngine } from '../session/sessionAPI';

export const addNotificationAsync = createAsyncThunk(
  "ui/addNotification",
  async (payload, thunkAPI) => {
    const id = uuidv4().slice(0, 8);
    const notificationTimeout = thunkAPI.getState().ui.clientConfig.features.notifications.timeout;
    setTimeout(()=> {
      thunkAPI.dispatch(removeNotification(id))
    }, notificationTimeout)
    return {...payload, id};
  }
);

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {

	// pgw 01-aug-2025
	setLibraryEndpoint: (state, action) => {

		// pgw 03-aug-2025
// 		console.log('setLibraryEndpoint p1')

	  if (!state.clientConfig.features) {
		// console.log('setLibraryEndpoint p2 state.clientConfig.features not defined - setting to empty')
		state.clientConfig.features = {};
	  }
	  if (!state.clientConfig.features.library) {
		// console.log('setLibraryEndpoint p3 state.clientConfig.features.library not defined - setting to empty')
		state.clientConfig.features.library = {};
	  }

		// console.log('setLibraryEndpoint p4 action.payload = ', action.payload)

		if (state.clientConfig.features.library.endpoint) {
			// console.log('useEffect p5 state.clientConfig.features.library.endpoint defined')
			// console.log('setLibraryEndpoint p6 state.clientConfig.features.library.endpoint = ', state.clientConfig.features.library.endpoint)
		}
		else {
			// console.log('setLibraryEndpoint p7 state.clientConfig.features.library.endpoint not defined')
		}

	  state.clientConfig.features.library.endpoint = action.payload;

	  // console.log('setLibraryEndpoint p8 state.clientConfig.features.library.endpoint = ', state.clientConfig.features.library.endpoint)

	},



    toggleSidebar: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setShowLyrics: (state, action) => {
      state.showLyrics = action.payload;
    },
    setNewTrackModalVisible: (state, action) => {
      state.newTrackModalVisible = action.payload;
    },
    setDismissedOfflineNotification: (state, action) => {
      state.dismissedOfflineNotification = action.payload;
    },
    setFeedbackModalVisible: (state, action) => {
      if (action.payload) {
        if (!localStorage.getItem("feedbackSubmittedA")) {
          state.feedbackModalVisible = true;
        }
      } else {
        state.feedbackModalVisible = false;
        localStorage.setItem("feedbackSubmittedA", true)
      }
      
    },
    setIOSModalVisible: (state, action) => {
      state.iOSModalVisible = action.payload;
    },
    setWasmMemoryUsage: (state, action) => {
      state.wasmMemoryUsage = action.payload;
    },
    setClientConfig: (state, action) => {
	  // console.log('setClientConfig p1 state.clientConfig = ', state.clientConfig)
      state.clientConfig = action.payload;
    },
    removeNotification: (state, action) => {
      state.notifications = [...state.notifications.filter(n => n.id !== action.payload)];
    },
    resetNotifications: (state, action) => {
      state.notifications = [];
    },
    submitFeedback: (state, action) => {
      ReactGA.event(
        'user_feedback',
        action.payload
      );
      localStorage.setItem("feedbackSubmittedA", true)
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setUserInputtingText: (state, action) => {
      state.userInputtingText = action.payload;
    },
    setSoloMode: (state, action) => {
      state.soloMode = action.payload;
    },
    setShowDeveloperTools: (state, action) => {
      state.showDeveloperTools = action.payload;
    },
    setParentVersion: (state, action) => {
      state.parentVersion = action.payload;
    },
    setOfflineModalVisible: (state, action) => {
      state.offlineModalVisible = action.payload;
    },
    setAppStarted: (state, action) => {
      state.appStarted = action.payload;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder.addCase(addNotificationAsync.fulfilled, (state, action) => {
      state.notifications = [...state.notifications, action.payload];
    })
  },
});

// export const { setSoloMode, setError, toggleSidebar, removeNotification, resetNotifications, setWasmMemoryUsage, setNewTrackModalVisible, setIOSModalVisible, setFeedbackModalVisible, submitFeedback, setDismissedOfflineNotification, setClientConfig, setShowLyrics, setUserInputtingText, setShowDeveloperTools, setParentVersion, setOfflineModalVisible, setAppStarted } = uiSlice.actions;
export const { setSoloMode, setError, toggleSidebar, removeNotification, resetNotifications, setWasmMemoryUsage, setNewTrackModalVisible, setIOSModalVisible, setFeedbackModalVisible, submitFeedback, setDismissedOfflineNotification, setClientConfig, setShowLyrics, setUserInputtingText, setShowDeveloperTools, setParentVersion, setOfflineModalVisible, setAppStarted, setLibraryEndpoint } = uiSlice.actions;

export const selectSidebarOpen = (state) => state.ui.sidebarOpen;

export const selectNotifications = (state) => state.ui.notifications;

export const selectNewTrackModalVisible = (state) => state.ui.newTrackModalVisible;
export const selectFeedbackModalVisible = (state) => state.ui.feedbackModalVisible;

export const selectDismissedOfflineNotification = (state) => state.ui.dismissedOfflineNotification;
export const selectiOSModalVisible = (state) => state.ui.iOSModalVisible;

export const selectClientConfig = (state) => state.ui.clientConfig;
export const selectShowLyrics = (state) => state.ui.showLyrics;

export const selectUserInputtingText = (state) => state.ui.userInputtingText;

export const selectSoloMode = (state) => state.ui.soloMode;

export const selectError = (state) => state.ui.error;
export const selectShowDeveloperTools = (state) => state.ui.showDeveloperTools;
export const selectParentVersion = (state) => state.ui.parentVersion;
export const selectOfflineModalVisible = (state) => state.ui.offlineModalVisible;
export const selectAppStarted = (state) => state.ui.appStarted;

export default uiSlice.reducer;
